import React, { useContext, useState } from "react"; // Add useContext here
import { useNavigate } from "react-router-dom"; // to handle redirection
import { AuthContext } from "../context/AuthContext";

export default function LoginForm() {
  const API_BASE = "https://api.cloud.linkbms.eu";
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [showRecoveryForm, setShowRecoveryForm] = useState(false);
  const [recoveryMessage, setRecoveryMessage] = useState("");
  const [recoveryError, setRecoveryError] = useState("");
  const [sendingRecovery, setSendingRecovery] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate(); // React Router hook for navigation
  const { loginSuccess } = useContext(AuthContext); // Update session after successful login

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Sending login request to the server
    try {
      const response = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
        credentials: "include"
      });

      const text = await response.text();

      console.log("LOGIN STATUS:", response.status);
      console.log("LOGIN RESPONSE:", text);

      let data = {};
      try {
        data = JSON.parse(text);
      } catch (e) {
        data = { error: text || "Server returned non-JSON response" };
      }

      if (response.ok) {
        await loginSuccess(); // refresh session state from server
        navigate("/"); // Redirect to homepage after successful login
      } else {
        setErrorMessage(data.error); // Set error message
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  const handlePasswordRecovery = async (event) => {
    event.preventDefault();
    setRecoveryError("");
    setRecoveryMessage("");

    if (!recoveryEmail.trim()) {
      setRecoveryError("Please enter your email address.");
      return;
    }

    setSendingRecovery(true);
    try {
      const response = await fetch(`${API_BASE}/password_reset/request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email: recoveryEmail.trim() }),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setRecoveryError(data.error || "Could not send password reset email.");
        return;
      }

      setRecoveryMessage(
        data.message || "If this email exists in our system, a password reset link has been sent."
      );
      setRecoveryEmail("");
    } catch (error) {
      setRecoveryError("An error occurred. Please try again.");
    } finally {
      setSendingRecovery(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
      {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}{" "}
        <table>
          <thead>
            <tr></tr>
            <th colSpan="2">Login to LinkCloud</th>
          </thead>
          <tbody>
            <tr>
              <td>
                <label htmlFor="username">Username:</label>
              </td>
              <td>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </td>
            </tr>

            <tr>
              <td>
                <label htmlFor="password">Password:</label>
              </td>
              <td>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </td>
            </tr>
          </tbody>
        </table>

        <br />
        <br />
        <button type="button" onClick={() => navigate("/register")}>Register</button>
        <br />
        <br />
        {!showRecoveryForm && (
          <button
            type="button"
            onClick={() => {
              setShowRecoveryForm(true);
              setRecoveryError("");
              setRecoveryMessage("");
            }}
          >
            Forgot password?
          </button>
        )}

        {showRecoveryForm && (
          <div style={{ marginTop: "12px" }}>
            <label htmlFor="recovery-email">Recovery email:</label>
            <br />
            <input
              type="email"
              id="recovery-email"
              value={recoveryEmail}
              onChange={(e) => setRecoveryEmail(e.target.value)}
              required
            />
            <br />
            <br />
            <button type="button" onClick={handlePasswordRecovery} disabled={sendingRecovery}>
              {sendingRecovery ? "Sending..." : "Send reset email"}
            </button>
            <button
              type="button"
              style={{ marginLeft: "8px" }}
              onClick={() => {
                setShowRecoveryForm(false);
                setRecoveryEmail("");
                setRecoveryError("");
                setRecoveryMessage("");
              }}
            >
              Cancel
            </button>
            {recoveryError && <p style={{ color: "red" }}>{recoveryError}</p>}
            {recoveryMessage && <p style={{ color: "green" }}>{recoveryMessage}</p>}
          </div>
        )}
        <br />
        <br />
        <input type="submit" value="Login" />
      </form>
    </div>
  );
}
